<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#chevron-up__a)">
    <path d="M2.265 18.791a1 1 0 0 0 1.416 0L12 10.457l8.32 8.334a1 1 0 0 0 1.415 0l1.56-1.563a1 1 0 0 0 0-1.413L12.708 5.209a1 1 0 0 0-1.416 0L.705 15.815a1 1 0 0 0 0 1.413l1.56 1.563Z"/>
  </g>
  <defs>
    <clipPath id="chevron-up__a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
